export default  {"src":"/_next/static/image/public/assets/nevo-boi/loader.7a2e1ebf192ddfb235054aa8e88f12d7.svg","height":48,"width":48};